import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import PartService from "../Controller/PartController"
import PartsDetailModal from "./PartsDetail";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Common from '../../Common/Common';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import SageService from '../../Sage/Controller/SageController';
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import StockBatchSearchModal from "./PartForms/StockBatchSearchModal";
import SearchStockSerialModal from "./PartForms/SearchStockSerialModal";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import QuickbookService from '../../Quickbook/QuickbookController';
import XeroService from '../../Xero/XeroController';
function PartListPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const HelpLink = localStorage.getItem('HelpLink');
    const location = useLocation();
    const url = new URL(window.location.origin + location.pathname);
    const pathname = "/part/part-list"
    const tableRef = useRef();
    const FormAction = "/PartList";
    //  FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const [modalInstance, setModalInstance] = useState(null);
    const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
    const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    const [selectedId, setSelectedId] = useState("0");
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [partList, setPartData] = useState([]);
    const [filteredParts, setFilteredParts] = useState([]);
    const [isSerialModalOpen, setIsSerialModalOpen] = useState(false);
    const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const [StockID, setStockID] = useState("0");
    const [multipleIds, setMultipleIds] = useState([]);
    const CompanyID = localStorage.getItem("CompanyID");
    const UserID = localStorage.getItem("UserID");
    const activeDateFormat = useDateFormat();
    const setSortConfigInCookie = (config) => {
        Cookies.set(`PartSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`PartSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };

    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

    useEffect(() => {
        UserLockRelease();
        fetchParts(currentPage, pageSize);
    }, [currentPage, pageSize]);

    useEffect(() => {
        fetchParts(currentPage, pageSize);
    }, [sortConfig]);

    const UserLockRelease = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchParts = async (page, size) => {
        try {

            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();


            const data = await PartService.GetAllNewParts(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
            setFilteredParts(data);
            setPartData(data);


            const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery);
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    useEffect(() => {
        IsModuleAssigned();
        fetchParts("0", pageSize);
    }, []);


    const handleCloseModal = async () => {
        await PartService.UnLockPart(localStorage.getItem('StockID'));
        if (localStorage.getItem('HasRecordUpdated') == "1") {

            fetchParts("0", pageSize);
        }
        setMultipleIds([]);
        setIsModalOpen(false);
    };
    const handleBatchCloseModal = () => {
        setStockID("0");
        setIsBatchModalOpen(false);
    };
    const handleSerialCloseModal = () => {
        setStockID("0");
        setIsSerialModalOpen(false);
    };
    const handleDeleteClick = async (event) => {
        event.stopPropagation(); // Prevent the row click event
        if (multipleIds.length > 0) {
            Swal.fire({
                title: 'Are you sure?',
                text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('confirmDelete')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await PartService.DeletePart(redirectCallback, multipleIds);
                        setMultipleIds([]);
                        fetchParts("0", pageSize);
                        setSelectedId("0");
                        Swal.fire(
                            t('deleted'),
                            t('deleteSuccess'),
                            'success'
                        );
                    } catch (error) {
                        console.error('Error deleting job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem deleting the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to delete part.',
                'warning'
            );
        }
    };

    const handleCreatePartClick = () => {
        localStorage.setItem('StockID', "");
        localStorage.setItem('StockID', "0");
        localStorage.setItem('HasRecordUpdated', "0");
        setIsModalOpen(true);
    };
    const fetchPartDetail = async (PartID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const PartDetail = await PartService.GetPartByID(redirectCallback, PartID);
            return PartDetail;

        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };

    const handleEditClick = (StockID) => {
        try {
            localStorage.setItem('StockID', StockID);
            localStorage.setItem('HasRecordUpdated', "0");
            navigate(`/PartDetailMobile?JobID=${StockID}`);
        }
        catch (error) {
            alert(error);
        }
    };




    

    const truncateText = (text, maxLength = 20) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const getRowColor = (freeStock, rangeFrom, rangeTo) => {
        if (parseFloat(freeStock) < parseFloat(rangeFrom)) {

            return 'red';
        } else if (parseFloat(freeStock) > parseFloat(rangeTo)) {
            return 'blue';
        }
        return 'black'; // Default color or any other color you'd like
    };
    const filterParts = (color) => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        if (color === 'red') {
            setFilteredParts(partList.filter(part => getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) === 'red'));
        } else if (color === 'blue') {
            setFilteredParts(partList.filter(part => getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) === 'blue'));
        } else {
            // Reset to show all parts
            setFilteredParts(partList);
        }
    };
    const handleCheckboxChange = (event, id) => {
        event.stopPropagation();
        setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
        setMultipleIds((prevSelectedIds) => {
            if (event.target.checked) {
                return [...prevSelectedIds, id];
            } else {
                return prevSelectedIds.filter((selectedId) => selectedId !== id);
            }
        });
    };
    const handleSynchronize = async (event) => {
        event.stopPropagation(); // Prevent the row click event
        let ID = 0;
        for (const id of multipleIds) {
            ID = id;
        }
        if (ID > 0) {
            Swal.fire({
                title: t('areYouSure'),
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Synchronize!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const postData = await PartService.SyncPartToFinancial(multipleIds);
                        if (postData && postData.message === "Data saved successfully") {
                            Swal.fire(
                                'Success!',
                                'The data has been processed and will be fully synced shortly.',
                                'success'
                            );
                            await fetchParts("0", pageSize);
                        }
                    } catch (error) {
                        console.error('Error Synchronizing data:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem in synchronizing the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else {
            Swal.fire(
                'Error!',
                'Please select at least one record to synchronize.',
                'warning'
            );
        }

    };

    const handleSerialTracking = async (event) => {
        event.stopPropagation(); // Prevent the row click event
        let ID = 0;
        for (const id of multipleIds) {
            ID = id;
        }
        if (ID > 0) {
            const partDetail = await PartService.GetPartByID(redirectCallback, ID);
            if (partDetail[0].snt_SerialTracking > 0) {
                setIsSerialModalOpen(true);
            }
            else {
                Swal.fire(
                    'Error!',
                    'The serial tracking is not enabled for the selected part.',
                    'error'
                );
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please select at least one record to synchronize.',
                'warning'
            );
        }

    };

    const handleBatchManagement = async (event) => {
        event.stopPropagation(); // Prevent the row click event
        let ID = 0;
        for (const id of multipleIds) {
            ID = id;
        }
        if (ID > 0) {
            const partDetail = await PartService.GetPartByID(redirectCallback, ID);
            if (partDetail[0].bit_BatchManagement > 0) {

                setSelectedId(selectedId);
                setIsBatchModalOpen(true);
            }
            else {
                Swal.fire(
                    'Error!',
                    'The batch management is not enabled for the selected part.',
                    'error'
                );
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please select at least one record to synchronize.',
                'warning'
            );
        }

    };



    const redirecttoUnAuthorzied = () => {
        navigate('/Unauthorized'); // Redirect to the login page
    };

    const IsModuleAssigned = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            const Modules = await ModuleService.GetModuleByClientID(CompanyID, "4");
            if (Modules.length === 0) {
                Swal.fire(
                    'UnAuthorzied Access!',
                    'Sorry, You are not authorized to access this module.',
                    'warning'
                );
                redirecttoUnAuthorzied();
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handlePageChange = (page) => {
        setFilteredParts([]);
        setPartData([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page
        setFilteredParts([]);
        setPartData([]);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const leadData = await PartService.GetAllNewParts(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
        setFilteredParts(leadData);
        setPartData(leadData);

        const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery);
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically
    };
    const handleSort = async (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);

        setSortConfig({ key, direction });
        const porderData = await PartService.GetAllNewParts(redirectCallback, "1", pageSize.toString(),
            searchQuery.toString(), key.toString(), direction.toString());

        const porderCount = await PartService.GetPartCount(redirectCallback, searchQuery);

        setPOCount(porderCount[0].TotalRecords);
        setFilteredParts(porderData);
        setPartData(porderData);

        setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
    };

    const defaultColumns = [
        "vc_StockCode",
        "vc_StockName",
        "mon_StockPrice",
        "mon_SalesPrice",
        "FK_StockCategory_ID",
        "dec_Quantity",
        "dec_FreeStock",
        "dec_Allocated",
        "dec_OnOrder",
        "psync"
    ];

    const columnOptions = [
        { value: "vc_StockCode", label: "Product Code" },
        { value: "vc_StockName", label: "Description" },
        { value: "mon_StockPrice", label: "Cost Price" },
        { value: "mon_SalesPrice", label: "Sale Price" },
        { value: "FK_StockCategory_ID", label: "Discount Category" },
        { value: "dec_Quantity", label: "In Stock" },
        { value: "dec_FreeStock", label: "Free Stock" },
        { value: "dec_Allocated", label: "Allocated" },
        { value: "dec_OnOrder", label: "On Order" },
        { value: "UpdatedDate", label: "Updated Date" },
        { value: "psync", label: "Sync" }
    ];
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`PartsColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`PartsColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };


    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            <div className="main-content-header row mb-3">

                <div className="col-sm-12">
                    <h1>Parts</h1>
                </div>

            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">

                            <div className="table-responsive">



                                <div className="row mb-3 d-flex align-items-center">
                                    {/* Page Size Selector */}
                                    <div className="col-4 col-md-3 d-flex align-items-center">

                                        <select
                                            id="pageSize"
                                            className="form-control form-control-sm"
                                            value={pageSize}
                                            onChange={handlePageSizeChange}
                                        >
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                    </div>

                                    {/* Search Field */}
                                    <div className="col-8 col-md-3 d-flex align-items-center justify-content-end">
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="form-control form-control-sm me-2"
                                            placeholder="Search..."
                                        />
                                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                            <img src="assets/img/resources/search.png" className="top-icon" alt="Search" />
                                        </button>
                                    </div>
                                </div>




                                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <tbody>
                                            {filteredParts.map((part, index) => (
                                                <>
                                                    <tr key={index} onClick={() => handleEditClick(part.PK_Stock_ID)}>
                                                        <td style={{
                                                            fontWeight: 'bold',
                                                            padding: '10px',
                                                            width: '70%',
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word'
                                                        }}>
                                                            {part.vc_StockCode}
                                                        </td>
                                                        <td style={{
                                                            textAlign: 'right',
                                                            padding: '10px',
                                                            fontWeight: 'bold',
                                                            width: '30%'
                                                        }}>
                                                            {part.dec_FreeStock}
                                                        </td>
                                                    </tr>
                                                    <tr key={index} onClick={() => handleEditClick(part.PK_Stock_ID)}>
                                                        <td colSpan="2" style={{
                                                            padding: '10px',
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                            borderBottom: '1px solid #ccc',
                                                        }}>
                                                            {part.vc_Description && part.vc_Description.length > 80
                                                                ? `${part.vc_Description.substring(0, 80)}...`
                                                                : part.vc_Description}
                                                        </td>
                                                    </tr>
                                                </>
                                            ))}
                                        </tbody>
                                        <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white", marginTop: "10px", marginBottom: "10px" }}>
                                            <tr>
                                                <td colSpan={11}>
                                                    <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>


                                                        {/* Last Page Button */}
                                                        <button
                                                            style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            Last
                                                        </button>

                                                        {/* Next Page Button */}
                                                        <button
                                                            style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            Next
                                                        </button>

                                                        <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                            Page {currentPage} of {totalPages}
                                                        </span>

                                                        {/* Previous Page Button */}
                                                        <button
                                                            style={{ padding: '5px 8px', float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                            disabled={currentPage === 1}
                                                        >
                                                            Prev
                                                        </button>

                                                        {/* First Page Button */}
                                                        <button
                                                            style={{ padding: '5px 8px', float: "right" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(1)} // Navigate to first page
                                                            disabled={currentPage === 1}
                                                        >
                                                            First
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>



                                    {/* Page Size Selector */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PartListPage;